export const DOMINIO_TERPEL="TERPEL"
export const DOMINIO_FUELLY="FUELLY"
export const DOMINIO_FIREFUEL="FIREFUEL"
export const DOMINIO_ENCOGNV="ENCOGNV"